module.exports = __webpack_public_path__ + "img/place25.fe60a4a1.jpg";